import { Observable } from "rxjs/Observable"

import {
    getAuthHeader,
    postImageConfig,
    postJSONConfig,
    dashboardBaseUrl
} from "./utils/network-config"

export function postImage(token, type, id, image) {
    const isCopyFrom = typeof image === "string" || image instanceof String
    const imageConfig = (isCopyFrom ? postJSONConfig : postImageConfig)(
        image,
        token
    )
    return Observable.ajax
        .post(
            getImageURL(type, id, isCopyFrom && image),
            imageConfig.body,
            imageConfig.headers
        )
        .map(xhr => xhr.response)
}

export function deleteImage(token, type, id) {
    return Observable.ajax
        .delete(getImageURL(type, id), getAuthHeader(token))
        .map(xhr => xhr.response)
}

export function getImageAPIFunction(image) {
    return image === null ? deleteImage : postImage
}

function getImageURL(type, id, copyFrom) {
    const baseURL = `${dashboardBaseUrl}/image/${type}/${id}`
    return copyFrom
        ? `${baseURL}?copy_from=${encodeURIComponent(copyFrom)}`
        : baseURL
}
